'use client';
import { useRef } from 'react';
import { getDeviceType, type DeviceType } from '.';

export const useDeviceType = (): DeviceType => {
  const isClient = typeof window !== 'undefined';
  const deviceType = useRef(isClient ? getDeviceType(window.navigator.userAgent) : 'mobile');
  return deviceType.current;
};
